module.exports = "/images/star_full.svg?022ee8ee328a6094968e1de786919a91";